<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row">
        <div class="col-xl-7"><img class="bg-img-cover bg-center" src="../../assets/images/login/1.jpg"
                                   alt="looginpage"></div>
        <div class="col-xl-5 p-0">
          <div class="login-card">
            <div>
              <div>
                <a class="logo">
                  <img
                      class="img-fluid for-light"
                      src="../../assets/images/logo/login.png"
                      alt="looginpage"
                  />
                  <img
                      class="img-fluid for-dark"
                      src="../../assets/images/logo/logo_dark.png"
                      alt="looginpage"
                  />
                </a>
              </div>
              <div class="login-main login-form-card">
                <form class="theme-form" @submit.prevent="registration">
                  <h4>Create your account</h4>
                  <p>Enter your personal details to create account</p>
                  <div class="form-group">
                    <label class="col-form-label pt-0">Your Name</label>
                    <div class="form-row">
                      <div class="col-12">
                        <input class="form-control" v-model="name" type="text" required=""
                               placeholder="First and last name">
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Email Address</label>
                    <input class="form-control" v-model="email" type="email" required="" placeholder="Test@gmail.com">
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Password</label>
                    <input class="form-control" v-model="password" type="password" name="login[password]" required=""
                           placeholder="*********">
                    <div class="show-hide"><span class="show"></span></div>
                  </div>
                  <div class="form-group mb-0">
                    <div class="checkbox p-0">
                      <input id="checkbox1" type="checkbox">
                      <label class="text-muted" for="checkbox1">Agree with<a class="ml-2" href="#">Privacy
                        Policy</a></label>
                    </div>
                    <button class="btn btn-primary btn-block" type="submit">Create Account</button>
                  </div>
                  <p class="mt-4 mb-0">Already have an account?
                    <router-link class="ml-2" tag="a" to="/authentication/login">
                      Login
                    </router-link>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {
      name: "",
      email: "",
      password: "",
    };
  },
  methods: {
    registration() {
      this.submitted = true;
      const {dispatch} = this.$store;
      if (this.name && this.email && this.password) {
        dispatch("authentication/registration", {
          'name': this.name,
          'email': this.email,
          'password': this.password
        });
      }
    },
  },
};
</script>